/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AllocationAssistanceModal_viewer$ref: FragmentReference;
declare export opaque type AllocationAssistanceModal_viewer$fragmentType: AllocationAssistanceModal_viewer$ref;
export type AllocationAssistanceModal_viewer = {|
  +company: ?{|
    +monday: ?number,
    +tuesday: ?number,
    +wednesday: ?number,
    +thursday: ?number,
    +friday: ?number,
    +saturday: ?number,
    +sunday: ?number,
  |},
  +project: ?{|
    +id: string,
    +projectHealth: ?{|
      +allocationAssistance: ?$ReadOnlyArray<?{|
        +role: ?{|
          +id: string,
          +name: ?string,
        |},
        +missingAllocation: ?number,
      |}>
    |},
  |},
  +$refType: AllocationAssistanceModal_viewer$ref,
|};
export type AllocationAssistanceModal_viewer$data = AllocationAssistanceModal_viewer;
export type AllocationAssistanceModal_viewer$key = {
  +$data?: AllocationAssistanceModal_viewer$data,
  +$fragmentRefs: AllocationAssistanceModal_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "ID"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "focus",
      "type": "Float"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "performance",
      "type": "Float"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AllocationAssistanceModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "monday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tuesday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "wednesday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thursday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "friday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "saturday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sunday",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectHealth",
          "kind": "LinkedField",
          "name": "projectHealth",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "focus",
                  "variableName": "focus"
                },
                {
                  "kind": "Variable",
                  "name": "performance",
                  "variableName": "performance"
                }
              ],
              "concreteType": "MissingRoleAllocationType",
              "kind": "LinkedField",
              "name": "allocationAssistance",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "role",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "missingAllocation",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '96cb3ea675a2a01deffc9b490a60d4bc';

module.exports = node;
